import classnames from 'classnames'
import React from 'react'

import { Breadcrumbs } from '@driftt/tide-core'

import './style.css'

const ObjectListLayout = ({
  children,
  title,
  breadcrumbs
}) => {

  return (
    <div className={classnames("crm-object-list-layout", { "crm-object-list-layout--with-breadcrumbs": breadcrumbs?.length })}>
      <header>
        {breadcrumbs && <Breadcrumbs className="crm-object-list-layout--breadcrumbs" headings={breadcrumbs} />}
        <h1>{title}</h1>
      </header>

      <div className="crm-object-list-layout--content">
        {children}
      </div>
    </div>
  )
}

export default ObjectListLayout
